export default "/images/vendor/@coreui/icons/svg/flag/cif-kh.svg?36608fb1d3bdc6178d02b71034094213";